import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de acaricidas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarAcaricidas(props) {
  useEffect(() => {
    const title = 'acaricida.cadastroDeAcaricida';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'acaricidas'}
      insumoEnum={Insumo.ACARICIDA}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'acaricida.' +
          (props.match.params.id
            ? 'acaricidaEditadoComSucesso'
            : 'acaricidaCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'acaricida.' +
          (props.match.params.id
            ? 'falhaAoEditarAcaricida'
            : 'falhaAoCadastrarAcaricida')
      )}
      falhaCarregarMensagem={formatMessage('acaricida.falhaAoCarregarAcaricida')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarAcaricidas));
